import React, { useState } from "react";
import cn from "classnames";
import styles from "./Trainer.module.sass";
import Item from "./Item";

const items = [
  {
    name: "Rachid TEBBOUB",
    type: "WakeUpSuccess",
    
    review: [
      {
        author: "Rachid TEBBOUB",
        description: "Directeur - WakeUpSuccess",
        logo: "/images/content/WakeUpSuccess.png",
        image: "/images/content/testimonial1.jpg",
        image2x: "/images/content/testimonial1.jpg",
        comment:
          " Edutio a rendu notre audit Qualiopi simple et sans stress. La gestion des élèves est un vrai plaisir, tout est centralisé. Un gain de temps incroyable et une traçabilité parfaite.",
      },
    ],
  },
  // {
  //   name: "Eva Lolivier",
  //   type: "Centre Européen de formation",

  //   review: [
  //     {
  //       author: "Eva Lolivier",
  //       description: "Directeur - Centre Européen de formation",
  //       logo: "/images/content/cef.png",
  //       image: "/images/content/testimonial2.jpg",
  //       image2x: "/images/content/testimonial2.jpg",
  //       comment:
  //         "Edutio est une outil fabuleux ! L'équipe a été à l'écoute de nos besoins et a rendu la mise en place de la plateforme extrêmement simple. Leur outil nous a fait gagner un temps précieux dans la gestion des contrats des alternants. ",
  //     },
  //   ],
  // },
];

const Trainer = ({ className }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  return (
    <div className={cn(styles.section, className)}>
      <div className={cn("container", styles.container)}>
        <div className={styles.list}>
          {items[activeIndex].review.map((x, index) => (
            <Item item={x} key={index} />
          ))}
        </div>
        <div className={styles.nav}>
          {items.map((x, index) => (
            <div
              className={cn(styles.link, {
                [styles.active]: index === activeIndex,
              })}
              onClick={() => setActiveIndex(index)}
              key={index}
            >
              <div className={styles.details}>
                <div className={styles.man}>{x.name}</div>
                <div className={styles.position}>{x.type}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Trainer;
